import React from 'react';
import { KYCFieldRow } from './KYCFieldRow';
import { KYCField } from './PersonalInfoTab';
interface FinancialTabProps {
  fields: KYCField[];
  onFieldChange: (id: string, updates: Partial<KYCField>) => void;
  onSelectAll: (selected: boolean) => void;
}
// Define field metadata with Data Type, Regex, and Explanation
const fieldMetadata: Record<string, {
  fieldType: KYCField['fieldType'];
  regex?: string;
  explanation?: string;
  dropdownOptions?: string[];
}> = {
  monthly_sales_volume: {
    fieldType: 'number',
    regex: '^\\d+(\\.\\d{1,2})?$',
    explanation: 'Matches numeric values with optional two decimal points (e.g., 1000, 1000.99).'
  },
  transaction_volume_category: {
    fieldType: 'dropdown',
    regex: '^[A-Za-z\\s]+$',
    explanation: 'Matches alphabetic characters and spaces, suitable for categories like Low, Medium, High.',
    dropdownOptions: ['Low', 'Medium', 'High']
  },
  average_transaction_spend: {
    fieldType: 'number',
    regex: '^\\d+(\\.\\d{1,2})?$',
    explanation: 'Matches numeric values with optional decimal points (up to two decimals).'
  },
  pos_sales_share: {
    fieldType: 'number',
    regex: '^(100(\\.0{1,2})?|(\\d{1,2}(\\.\\d{1,2})?))$',
    explanation: 'Matches values between 0 and 100 with optional decimals, representing a percentage.'
  },
  cash_sales_share: {
    fieldType: 'number',
    regex: '^(100(\\.0{1,2})?|(\\d{1,2}(\\.\\d{1,2})?))$',
    explanation: 'Similar to POS Sales Share but for cash sales.'
  },
  pos_transaction_frequency: {
    fieldType: 'number',
    regex: '^\\d+$',
    explanation: 'Matches numeric values only, suitable for frequency counts.'
  }
};
export function FinancialTab({
  fields,
  onFieldChange,
  onSelectAll
}: FinancialTabProps) {
  const allSelected = fields.length > 0 && fields.every(f => f.selected);
  return <div className="space-y-6 py-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-382">
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-383">
        <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex items-center justify-between" data-id="element-384">
          <div className="flex items-center" data-id="element-385">
            <input type="checkbox" checked={allSelected} onChange={e => onSelectAll(e.target.checked)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer" data-id="element-386" />
            <span className="ml-4 text-sm font-semibold text-gray-700" data-id="element-387">
              Financial & Sales Information
            </span>
          </div>
          <div className="flex space-x-12 pr-6" data-id="element-388">
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider w-24 text-center" data-id="element-389">
              Configuration
            </span>
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-390">
          {fields.map(field => {
          const metadata = fieldMetadata[field.id] || {
            fieldType: 'text'
          };
          return <KYCFieldRow key={field.id} label={field.label} isSelected={field.selected} isMandatory={field.mandatory} isOptional={field.optional} fieldType={metadata.fieldType} regex={metadata.regex} explanation={metadata.explanation} dropdownOptions={metadata.dropdownOptions} onToggleSelect={checked => onFieldChange(field.id, {
            selected: checked
          })} onToggleMandatory={checked => onFieldChange(field.id, {
            mandatory: checked,
            optional: checked ? false : field.optional
          })} onToggleOptional={checked => onFieldChange(field.id, {
            optional: checked,
            mandatory: checked ? false : field.mandatory
          })} data-id="element-391" />;
        })}
        </div>
      </div>
    </div>;
}